import { render, staticRenderFns } from "./ParentsByCorral.vue?vue&type=template&id=065541f8&scoped=true"
import script from "./ParentsByCorral.vue?vue&type=script&lang=js"
export * from "./ParentsByCorral.vue?vue&type=script&lang=js"
import style0 from "./ParentsByCorral.vue?vue&type=style&index=0&id=065541f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065541f8",
  null
  
)

export default component.exports